import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-features-project',
  templateUrl: './features-project.component.html',
  styleUrls: ['./features-project.component.scss']
})
export class FeaturesProjectComponent implements OnInit {

  constructor() { }

  services = [
    // boat
    {
      imageUrl: '../../../../assets/images/patch/projectsBg/boat.png',
      iconUrl: '../../../../assets/images/patch/projectsBg/boatLogo.png',
      desc: 'BoAt that markets earphones, headphones stereos, travel chargers and premium rugged cables.',
    },
    // pokemon
    {
      imageUrl: '../../../../assets/images/patch/projectsBg/pokemonCenter.png',
      iconUrl: '../../../../assets/images/patch/projectsBg/pokemonLogo.png',
      desc: 'Pokémon Center is the official site for Pokémon shopping, featuring original items such as plush, clothing, figures, Pokémon TCG trading cards, and more.',
    },

    // stage
    {
      imageUrl: '../../../../assets/images/patch/projectsBg/stage3.png',
      iconUrl: '../../../../assets/images/patch/projectsBg/stage3Logo.png',
      desc: 'Stage3 is India’s first social shopping app for next-gen fashion lovers. Find unique fashion, sell your style and shop with your tribe.',
    },
    // zadinga
    {
      imageUrl: '../../../../assets/images/patch/projectsBg/zadinga.png',
      iconUrl: '../../../../assets/images/patch/projectsBg/zadingaLogo.png',
      desc: 'Zadinga is the best shop management app for retail businesses. It makes it easy to set up an online store and manage all your stock in one place.',
    },
    // jio
    {
      imageUrl: '../../../../assets/images/patch/projectsBg/jio.png',
      iconUrl: '../../../../assets/images/patch/projectsBg/jioLogo.png',
      desc: 'Simplify the digital journey of your business with us.',
    },
    // uolo
    {
      imageUrl: '../../../../assets/images/patch/projectsBg/uolo.png',
      iconUrl: '../../../../assets/images/patch/projectsBg/uoloLogo.png',
      desc: 'Uolo It can be used by educators to communicate content-rich information with parents and students.',
    },
    // echo
    {
      imageUrl: '../../../../assets/images/patch/projectsBg/echo.png',
      iconUrl: '../../../../assets/images/patch/projectsBg/echoLogo.png',
      desc: 'Addressing the needs of the underserved communities by building capacities using the ECHO Model',
    },
    // bricknbolt
    {
      imageUrl: '../../../../assets/images/patch/projectsBg/brickNbolt.png',
      iconUrl: '../../../../assets/images/patch/projectsBg/brickNboltLogo.png',
      desc: 'Brick&Bolt is a construction company in Bengaluru doing house construction, building construction, & commercial construction.',
    },
    // boost
    {
      imageUrl: '../../../../assets/images/patch/projectsBg/boost.png',
      iconUrl: '../../../../assets/images/patch/projectsBg/boostLogo.png',
      desc: 'One app to manage your digital business.',
    },
    // gromo     pending imageurl
    {
      imageUrl: '../../../../assets/images/patch/projectsBg/gromoBg.png',
      iconUrl: '../../../../assets/images/patch/projectsBg/gromoLogo.png',
      desc: 'Gromo platform helps you to start your entrepreneurial journey.',
    },
    // chqbook
    {
      imageUrl: '../../../../assets/images/patch/projectsBg/chqbook.png',
      iconUrl: '../../../../assets/images/patch/projectsBg/chqbookLogo.png',
      desc: 'The App For Finance Professionals',
    },
    // tripleplay
    {
      imageUrl: '../../../../assets/images/patch/projectsBg/tripleplay.png',
      iconUrl: '../../../../assets/images/patch/projectsBg/tripleplayLogo.png',
      desc: 'The largest Triple play Service provider Company working over FTTH (Fiber to the Home) in India',
    },
    // irctc
    {
      imageUrl: '../../../../assets/images/patch/projectsBg/irctc.png',
      iconUrl: '../../../../assets/images/patch/projectsBg/irctcLogo.png',
      desc: 'Indian Railway Catering And Tourism Corporation Limited',
    },
    // disc
    {
      imageUrl: '../../../../assets/images/patch/projectsBg/disc.png',
      iconUrl: '../../../../assets/images/patch/projectsBg/discLogo.png',
      desc: 'Dubai International Sports Conference',
    },
    // beatroute
    {
      imageUrl: '../../../../assets/images/patch/projectsBg/beatroute.png',
      iconUrl: '../../../../assets/images/patch/projectsBg/beatrouteLogo.png',
      desc: '360 Intelligent Field Force CMR Platform For Merchandisers.',
    },
    // trgt
    {
      imageUrl: '../../../../assets/images/patch/projectsBg/trgt.png',
      iconUrl: '../../../../assets/images/patch/projectsBg/trgtLogo.png',
      desc: 'We deliver on point digital performance marketing.',
    },
    // dinehour
    {
      imageUrl: '../../../../assets/images/patch/projectsBg/dinehour.png',
      iconUrl: '../../../../assets/images/patch/projectsBg/dinehourLogo.png',
      desc: 'Restaurant Management System, Secure and reliable for users',
    },
    // sws
    {
      imageUrl: '../../../../assets/images/patch/projectsBg/sws.png',
      iconUrl: '../../../../assets/images/patch/projectsBg/swsLogo.png',
      desc: 'Dubai Sharajah Women’s Sports Club',
    },



    // {
    //   imageUrl: '../../../../assets/images/boostHeader.png',
    //   iconUrl: '../../../../assets/images/boostLogo.png',
    //   desc: 'One app to manage your digital business.',
    // },
    // {
    //   imageUrl: '../../../../assets/images/patch/projectsBg/gromoBg.png',
    //   iconUrl: '../../../../assets/images/patch/gromoLogo.png',
    //   desc: 'Gromo platform helps you to start your entrepreneurial journey.',
    // },
    // {
    //   imageUrl: '../../../../assets/images/patch/projectsBg/chqbookBg.png',
    //   iconUrl: '../../../../assets/images/patch/chqbookLogo.png',
    //   desc: 'THE APP FOR FINANCE PROFESSIONALS',
    // },
    // {
    //   imageUrl: '../../../../assets/images/patch/projectsBg/irctc.png',
    //   iconUrl: '../../../../assets/images/patch/irctcLogo.png',
    //   desc: 'Indian Railway Catering And Tourism Corporation Limited',
    // },
    // {
    //   imageUrl: '../../../../assets/images/patch/discBg.png',
    //   iconUrl: '../../../../assets/images/patch/discLogo.png',
    //   desc: 'DUBAI INTERNATIONAL SPORTS CONFERENCE',
    // },
    // {
    //   imageUrl: '../../../../assets/images/patch/projectsBg/beateRouteBg.png',
    //   iconUrl: '../../../../assets/images/patch/beatRouteLogo.png',
    //   desc: '360 Intelligent field force CRM platform for Merchandisers.',
    // },
    // {
    //   imageUrl: '../../../../assets/images/patch/projectsBg/contrastaffingBg.png',
    //   iconUrl: '../../../../assets/images/patch/contrastaffing.png',
    //   desc: 'Hire talent on demand at client site quickly and hassle free or Outsource your available resources quickly and grow your business.',
    // },
    // {
    //   imageUrl: '../../../../assets/images/patch/projectsBg/dineHourBg.png',
    //   iconUrl: '../../../../assets/images/patch/dinehourLogo.png',
    //   desc: 'Restaurant Management System, Secure and reliable for users',
    // },
    // {
    //   imageUrl: '../../../../assets/images/patch/projectsBg/swsBg.png',
    //   iconUrl: '../../../../assets/images/patch/swsLogo.svg',
    //   desc: 'Dubai Sharajah Women’s Sports club',
    // },
    // {
    //   imageUrl: '../../../../assets/images/patch/projectsBg/trgtBg.png',
    //   iconUrl: '../../../../assets/images/patch/projectsBg/trgtlogo.png',
    //   desc: 'We deliver on point digital performance marketing.',
    // },
    // {
    //   imageUrl: '../../../../assets/images/patch/projectsBg/tripleplayBg.png',
    //   iconUrl: '../../../../assets/images/patch/client-home/tripleplayLogo.png',
    //   desc: 'The largest Triple play Service provider Company working over FTTH (Fiber to the Home) in India',
    // },
    // {
    //   imageUrl: '../../../../assets/images/patch/iqbmp.png',
    //   iconUrl: '../../../../assets/images/patch/TEQIPlogo.png',
    //   desc: 'TEQIP PMSS',
    // },
  ]
  ngOnInit(): void {
  }

}
